import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const TOKEN: string | null = localStorage.getItem('token');

  if (TOKEN) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    return next(cloned);
  }
  return next(req);
};
